import React from 'react';
import { AnimatedSection } from './ui/AnimatedSection';
import { RefreshCw, AlertCircle, Frown, Moon } from 'lucide-react';
export function Problem() {
  return <AnimatedSection className="bg-white" data-id="element-171">
      <div className="max-w-4xl mx-auto" data-id="element-172">
        <div className="text-center mb-16 space-y-6" data-id="element-173">
          <h2 className="text-3xl md:text-4xl font-bold text-charcoal" data-id="element-174">
            La trampa de la "crianza perfecta"
          </h2>
          <p className="text-lg md:text-xl text-charcoal-light max-w-2xl mx-auto" data-id="element-175">
            Intentas ser la "madre presente" o el "padre consciente" que ves en
            redes sociales, pero la realidad de un hogar bilingüe, la carga
            mental y el cansancio acumulado te ganan la batalla cada tarde.
          </p>
        </div>

        <div className="bg-cream-dark/30 rounded-3xl p-8 md:p-12 border border-cream-dark" data-id="element-176">
          <h3 className="text-2xl font-bold text-center mb-10 text-charcoal" data-id="element-177">
            Vives en un bucle agotador:
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-178">
            {/* Connecting line for desktop */}
            <div className="hidden md:block absolute top-1/2 left-10 right-10 h-0.5 bg-mint-dark/30 -z-10 transform -translate-y-1/2" data-id="element-179" />

            <div className="bg-white p-6 rounded-2xl shadow-sm border border-mint-light text-center relative z-10 flex flex-col items-center gap-4" data-id="element-180">
              <div className="bg-red-50 text-red-500 p-4 rounded-full" data-id="element-181">
                <AlertCircle className="w-8 h-8" data-id="element-182" />
              </div>
              <h4 className="font-bold text-lg" data-id="element-183">1. La Explosión</h4>
              <p className="text-charcoal-light text-sm" data-id="element-184">
                Aguantas la tensión hasta que no puedes más y explotas con un
                grito que asusta a todos.
              </p>
            </div>

            <div className="bg-white p-6 rounded-2xl shadow-sm border border-mint-light text-center relative z-10 flex flex-col items-center gap-4" data-id="element-185">
              <div className="bg-blue-50 text-blue-500 p-4 rounded-full" data-id="element-186">
                <Frown className="w-8 h-8" data-id="element-187" />
              </div>
              <h4 className="font-bold text-lg" data-id="element-188">2. La Culpa</h4>
              <p className="text-charcoal-light text-sm" data-id="element-189">
                Pasas horas sumergido en una culpa paralizante mientras ellos
                duermen.
              </p>
            </div>

            <div className="bg-white p-6 rounded-2xl shadow-sm border border-mint-light text-center relative z-10 flex flex-col items-center gap-4" data-id="element-190">
              <div className="bg-gold/10 text-gold-dark p-4 rounded-full" data-id="element-191">
                <Moon className="w-8 h-8" data-id="element-192" />
              </div>
              <h4 className="font-bold text-lg" data-id="element-193">3. La Promesa Falsa</h4>
              <p className="text-charcoal-light text-sm" data-id="element-194">
                Prometes que "mañana será diferente". Pero sin herramientas
                tácticas, mañana termina siendo exactamente igual.
              </p>
            </div>
          </div>

          <div className="mt-12 flex justify-center" data-id="element-195">
            <div className="flex items-center gap-2 text-mint-dark font-medium bg-mint-light/50 py-2 px-6 rounded-full" data-id="element-196">
              <RefreshCw className="w-5 h-5 animate-spin-slow" style={{
              animationDuration: '4s'
            }} data-id="element-197" />
              <span data-id="element-198">Es hora de romper el ciclo</span>
            </div>
          </div>
        </div>
      </div>
    </AnimatedSection>;
}